import { IGraph } from "./IGraph";
import { IGraphOptions } from "../lib/types/selectedFilters";
import mapboxgl from 'mapbox-gl';
import { environment } from '../../../../../environments/environment';
import { MapboxGLButtonControl, PitchToggle } from '../../../modules/common/utility/custom-map-control';
export class BasicMapbox implements IGraph {
    map: mapboxgl.Map;

    chart: any = undefined;
    constructor() {
        (mapboxgl as typeof mapboxgl).accessToken = environment.mapbox.accessToken;
    }
    buildGraph(options: IGraphOptions): void {
        // console.log(options);
        const self = this;
        this.map = new mapboxgl.Map({
            container: options.id,
            style: options.data.style ? options.data.style : 'mapbox://styles/mapbox/light-v10',
            zoom: options.data.zoom ? options.data.zoom : 1,
            center: options.data.center ? options.data.center : [15.238727594792325, 18.384546523159326],
            minZoom: options.data.minZoom ? options.data.minZoom : 1,
            attributionControl: false,
            // renderWorldCopies: false,
            // interactive: false
        });
        this.map.addControl(new mapboxgl.NavigationControl(),
            options.data.ctrlPos
        );
        this.map.addControl(new PitchToggle({ minpitchzoom: 11 }), "top-left");
        this.map.addControl(new mapboxgl.FullscreenControl(), "top-left");
        this.map.addControl(new mapboxgl.ScaleControl(), "bottom-right");

        if (options.data.isGeolocation) {
            // this.map.on('load', () => {
            //     this.map.addSource('dem', {
            //         'type': 'raster-dem',
            //         'url': 'mapbox://mapbox.mapbox-terrain-dem-v1'
            //     });
            //     this.map.addLayer(
            //         {
            //             'id': 'hillshading',
            //             'source': 'dem',
            //             'type': 'hillshade'
            //         },
            //         'waterway-river-canal-shadow'
            //     );
            // })
        }
        // this.map.scrollZoom.disable();
        // this.map.dragRotate.disable();
        // this.map.touchZoomRotate.disableRotation();
    }
}
